export default "__VITE_ASSET__CAYxUZ0B__"